import type { NumberingStyle } from '@worldathletics/types';

const RomanValues: [number, string][] = [
  [1000, 'M'],
  [900, 'CM'],
  [500, 'D'],
  [400, 'CD'],
  [100, 'C'],
  [90, 'XC'],
  [50, 'L'],
  [40, 'XL'],
  [10, 'X'],
  [9, 'IX'],
  [5, 'V'],
  [4, 'IV'],
  [1, 'I'],
];

export const toRoman = (index: number): string => {
  let result = '';
  let remaining = index;
  for (const [value, numeral] of RomanValues) {
    while (remaining >= value) {
      result += numeral;
      remaining -= value;
    }
  }
  return result;
};

export const toAlpha = (index: number): string => {
  let result = '';
  let remaining = index;
  while (remaining > 0) {
    remaining--;
    result = String.fromCharCode(97 + (remaining % 26)) + result;
    remaining = Math.floor(remaining / 26);
  }
  return result;
};

export const formatIndex = (index: number, style: NumberingStyle): string => {
  switch (style) {
    case 'alpha_lower':
      return `(${toAlpha(index)})`;
    case 'alpha_upper':
      return `(${toAlpha(index).toUpperCase()})`;
    case 'roman_lower':
      return toRoman(index).toLowerCase();
    case 'roman_upper':
      return toRoman(index);
    case 'none':
      return '';
    case 'numeric':
    default:
      return String(index);
  }
};
